export enum DealDocumentCopyRequestStatus {
  NotProcessed = 0,
  Pending = 1,
  Success = 2,
  Failed = 3,
  NoDocumentsToCopy = 4
}